import styled from 'styled-components';
import { SelectContainer } from '../../../ui/atoms/CustomSelect/style';

export const TabsWrapper = styled.div`
  margin-top: 40px;

  @media ${(props) => props.theme.device.mobileL} {
    margin-top: 32px;
  }
`;

export const TabsWrapperMobile = styled(TabsWrapper)`
  border-bottom: 2px solid ${(props) => props.theme.colors.link};
  padding: 16px 24px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: ${(props) => props.theme.colors.link};

  ${SelectContainer} {
    width: unset;
  }

  div[class*='-control'] {
    border: none;
    width: fit-content;
  }

  div[class*='singleValue'] {
    color: ${(props) => props.theme.colors.link} !important;
    text-align: end;
  }

  div[class*='menu'] {
    min-width: 200px;
    right: 0;
  }
`;

export const TabContent = styled.div`
  display: none;
  &.active {
    display: block;
  }
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(props) => props.theme.colors.btnDisabledBg};
  margin: 40px auto;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;

  .percentage-label {
    position: absolute;
    left: 180px;
    top: 6px;

    @media ${(props) => props.theme.device.mobileL} {
      left: unset;
      right: 20px;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    align-items: start;
    flex-direction: column;

    > div,
    .d-flex {
      width: 100%;
    }
  }
`;
export const TagsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 32px;

  @media ${(props) => props.theme.device.mobileL} {
    gap: 8px;
    button {
      margin-top: 8px;
    }
  }
`;

export const CustomBox = styled.div`
  padding: 24px;
  background-color: ${(props) => props.theme.colors.bgBox};
  border-radius: 16px;

  @media ${(props) => props.theme.device.mobileL} {
    padding: 16px;
    margin-left: -16px;
    width: var(--full-width);
    border-radius: 0;
  }
`;
export const ActivitiesContainer = styled.div`
  .title-wrapper {
    margin-bottom: 18px;

    button {
      min-width: fit-content;
    }
  }
`;
export const Warning = styled.div`
  display: flex;
  gap: 8px;
  color: ${(props) => props.theme.colors.textSecondary};

  svg {
    margin-top: 6px;
    stroke: ${(props) => props.theme.colors.textSecondary};
  }
`;
